import { Link } from "react-router-dom";
import GameRates from "@/components/GameRates";

export default function GamePolicy() {
  return (
    <main className="min-h-screen bg-[#0B0E14] text-slate-200 px-5 py-10">
      <article className="max-w-xl mx-auto space-y-5 text-sm leading-relaxed">
        <Link to="/" className="text-emerald-400 underline">
          Back to app
        </Link>
        <h1 className="text-2xl font-bold text-white">Game policy</h1>
        <p className="text-xs text-slate-400">
          Effective 28 October 2026
        </p>
        <Link to="/how-to-play" className="block text-emerald-400 underline">
          How to Play — steps, compounding and referrals
        </Link>
        <section>
          <h2 className="font-semibold text-white mb-2">Daily rounds</h2>
          <p>
            Bet Call Down or Pull Up on your preferred coin for each day. That selection is recorded and
            locks after the first entry. Everyone choosing the selected
            direction for that coin and day wins; everyone choosing the other
            direction loses. Winning directions are not revealed before entry.
          </p>
        </section>
        <section>
          <h2 className="font-semibold text-white mb-2">Balance changes</h2>
          <p>
            New entries use percentages of your balance immediately before
            settlement, with your referral tier at settlement. Win rates are
            Rookie 2%, Bronze 4%, Silver 6%, Gold 10%, Platinum 12%, and Diamond
            15%. A loss subtracts half the win rate: 1%, 2%, 3%, 5%, 6%, or
            7.5%. Both directions use the same tier rates. Amounts round down to
            four decimal places. Deposits, withdrawals and earlier credits can
            change the calculation base. The entry temporarily reserves your
            current balance multiplied by your current loss rate, released on
            settlement; this hold is not a fixed stake or extra fee, and the
            actual result can differ. A positive balance is required to enter; no minimum deposit is needed to trade. Withdrawals require at least 50 USDT in cumulative deposits. You can enter once per day
            across all coins. The day resets at 5:00 AM IST. Results settle at
            the administrator’s daily time shown on your entry; schedule changes
            move all pending scheduled entries to the new future time. An entry
            after a result time waits for the next daily result. Pending entries
            block another entry across day resets. Service interruptions can
            delay settlement; overdue entries are retried. Earlier entries
            retain their accepted fixed payouts, commissions and recorded
            timing.
          </p>
        </section>
        <GameRates />
        <section>
          <h2 className="font-semibold text-white mb-2">
            Chain commission and compounding
          </h2>
          <p>
            For a winning new entry, each upline earns its tier rate of its own
            balance immediately before credit: Rookie 1%, Bronze 1.5%, Silver
            2%, Gold 3%, Platinum 4%, Diamond 8%, up to 100 levels with cycle
            protection. Losses do not generate chain commission. Direct
            referrals determine tiers. Retained earnings may compound; losses
            also change the base. Neither compounding nor referrals guarantee
            profit.
          </p>
        </section>
        <section>
          <h2 className="font-semibold text-white mb-2">
            Market charts and funds
          </h2>
          <p>
            Deposits are USDT only on the supported
            TRON, Ethereum and BSC networks. Deposits are manually reviewed by
            the administrator. Withdrawals are requests subject to the limits
            shown in your wallet; submitting a request does not mean a
            blockchain payout has occurred.
          </p>
        </section>
        <section>
          <h2 className="font-semibold text-white mb-2">Your agreement</h2>
          <p>
            Read these rules before entering. You can lose money and
            no profit is guaranteed. Earlier entries retain the rules recorded
            when they were submitted. Contact in-app support about deposits,
            settlement or withdrawals.
          </p>
        </section>
        <p className="text-[10px] text-slate-500">
          Android robot artwork by Google, adapted via Simple Icons under{" "}
          <a
            href="https://creativecommons.org/licenses/by/3.0/"
            className="underline"
          >
            CC BY 3.0
          </a>
          . Android is a trademark of Google LLC.
        </p>
      </article>
    </main>
  );
}
